import React from 'react';
import ProgressBar from '../../../../components/ui/ProgressBar';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import UserInformation from './GetStartedAccordionSections/UserProfile/UserInformation';
import StoreCreationForm from './GetStartedAccordionSections/StoreCreation/StoreCreationForm';
import { IonIcon } from '@ionic/react';
import { documentText } from 'ionicons/icons';

export default function SetupProgress() {
  const userProfile = useSelector((state: RootState) => state.userProfile);
  return (
    <div className="rounded-md p-4 sm:p-6 border bg-background dark:bg-background-accent">
      <div className="space-y-2 mb-6">
        <div className="gap-2 flex-wrap flex items-center">
          <IonIcon
            icon={documentText}
            className="h-12 w-12 text-primary dark:text-secondary"
          />
          <div className="flex-1">
            <h2 className="font-semibold text-lg  text-text-dark-high dark:text-text-light-high">
              Finish Setting up
            </h2>
            <p className="text-sm text-text-dark-medium dark:text-text-light-medium">
              Your setup progress
            </p>
          </div>
        </div>
        <ProgressBar progress={userProfile?.profile_progress_percent ?? 0} />
      </div>
      <div className="space-y-6">
        <UserInformation />
        <StoreCreationForm />
      </div>
    </div>
  );
}
